import CityServiceTemplate from "@/components/CityServiceTemplate";
import austinHero from "@/assets/cities/austin-hero.jpg";

const CarServiceAustin = () => {
  return (
    <CityServiceTemplate
      cityName="Austin"
      cityDescription="Premium point-to-point black car service between Austin and San Antonio. Perfect for business travelers, executives, and anyone seeking comfortable transportation across Central Texas."
      metaDescription="Luxury black car service from Austin to San Antonio. Professional chauffeur for business & leisure travel. Book now!"
      canonicalPath="/austin-car-service"
      heroImage={austinHero}
      additionalContent="Rick's Black Car Service provides seamless transportation between Austin and San Antonio metro areas. Whether you're commuting for business, attending an event, or need intercity travel, our professional chauffeurs ensure a smooth, productive journey in our luxury fleet."
      coordinates={{
        latitude: 30.2672,
        longitude: -97.7431
      }}
      serviceRadius="80 miles"
      cityReviews={[
        {
          author: "Christopher Davis",
          rating: 5,
          date: "2024-12-05",
          text: "Rick handles my regular Austin to San Antonio commute flawlessly. The 90-minute drive is comfortable and productive in his luxury Audi. Professional service at competitive rates. Highly recommend!"
        },
        {
          author: "Amanda Wilson",
          rating: 5,
          date: "2024-10-20",
          text: "Used Rick for AUS to SAT airport transfer. Despite heavy I-35 traffic, he navigated perfectly and got me to my flight on time. The vehicle was immaculate and Rick was professional and courteous."
        }
      ]}
    />
  );
};

export default CarServiceAustin;
